import UserAvailable from "@/entities/filters/UserAvailable";

const contractorsCollectionFiltersTemplate = {
  name: {
    matchField: "",
    matchValue: "",
    userId: []
},
  countries: [],
  states: {
    matchField: "",
    matchValue: "",
    userId: []
},
  cities: [],
  available: "all" as UserAvailable,
  titles: [],
  skills: [],
  managers: [],
  projects: [],
  minRate: "",
  maxRate: "",
};

export default contractorsCollectionFiltersTemplate;